import { LANGUAGES } from '../constants/defaultValues';

export const transformEventAddPayload = (message, { locale = LANGUAGES.eng } = {}) => {
    const { event: eventPayload, ...payload } = message;

    const { category, season: seasonPayload, ...eventData } = eventPayload;

    const categoryName = category.names[locale] || category.names[LANGUAGES.eng];

    const league = {
        categoryId: seasonPayload.categoryId,
        categoryName,
        countryCode: seasonPayload.countryCode,
        eventCount: seasonPayload.eventCount,
        id: seasonPayload.id,
        names: seasonPayload.names,
        order: seasonPayload.order,
    };

    const season = {
        categoryId: seasonPayload.categoryId,
        categoryName,
        countryCode: seasonPayload.countryCode,
        currentSeasonId: seasonPayload.currentSeasonId,
        events: [],
        frozen: seasonPayload.frozen,
        id: seasonPayload.id,
        mbn: seasonPayload.mbn,
        seasonName: seasonPayload.names[locale] || seasonPayload.names[LANGUAGES.eng],
        order: seasonPayload.order,
        sportTypeRefId: payload.sportId,
    };

    const event = {
        categoryName,
        countryCode: category.countryCode,
        currentSeasonId: season.currentSeasonId,
        favorite: eventData.favorite,
        frozen: eventData.frozen,
        id: eventData.id,
        leagueName: season.seasonName,
        live: eventData.live,
        liveStatistics: eventData.liveStatistics,
        markets: eventData.markets,
        mbn: eventData.mbn,
        moreMarkets: eventData.moreMarkets,
        order: eventData.order,
        programCode: eventData.programCode,
        seasonRefId: season.id,
        sportTypeRefId: eventData.sportTypeRefId,
        startedAt: eventData.startedAt,
        teams: eventData.teams,
    };

    return { payload, category, league, season, event };
};

export const updateSportEventCount = (sportsList, sportId, diff) => {
    return sportsList.map(sport => {
        if (sport.referenceId === sportId) {
            return {
                ...sport,
                eventCount: sport.eventCount + diff,
            };
        }

        return sport;
    });
};

export const sortAlphabetically = (a, b) => {
    // equal items sort equally
    if (a === b) {
        return 0;
    }

    // nulls sort after anything else
    else if (!a) {
        return 1;
    } else if (!b) {
        return -1;
    }

    return a.toString().localeCompare(b, undefined, { numeric: true });
};

export const sortEventsByLeague = locale => (a, b) => {
    if (a.order === undefined || b.order === undefined) return 1;

    const nameOne = a.names[locale] || a.names[LANGUAGES.eng];
    const nameTwo = b.names[locale] || b.names[LANGUAGES.eng];

    return a.order - b.order || nameOne.localeCompare(nameTwo);
};

export const sortEventsByTime = (a, b) => {
    return (
        b.liveStatistics?.currentPeriodNumber - a.liveStatistics?.currentPeriodNumber ||
        b.liveStatistics?.eventTimeInMinutes - a.liveStatistics?.eventTimeInMinutes ||
        sortAlphabetically(b.liveStatistics?.eventTime, a.liveStatistics?.eventTime) ||
        a.startedAt - b.startedAt ||
        sortAlphabetically(a.id, b.id)
    );
};

export const sortEventsByMbn = (a, b) => {
    return a.mbn - b.mbn || a.startedAt - b.startedAt || sortAlphabetically(a.id, b.id);
};
